import React from "react";
import CamasirSuyu from "../Components/product/CamasirSuyu";
import PageHeader from "../Components/common/PageHeader";
import ProductSEO from "../Components/common/ProductSEO";
import { t } from "i18next";

function CamasirSuyuPage() {
    return (
        <>
            <ProductSEO
                name="Çamaşır Suyu"
                description="Güçlü hijyen ve beyazlatma etkisiyle ev ve endüstriyel kullanımda etkili çamaşır suyu."
                slug="camasirsuyu"
                imagePath="assets/images/20-kg/2.webp"
            />
            <PageHeader title={t("ÇAMAŞIR SUYU")} />
            <CamasirSuyu />  
        </>
    );
}

export default CamasirSuyuPage;